import type { DigitalMediaPlan } from './types';

export const CAMPAIGN_OBJECTIVES = [
  'awareness',
  'engagement',
  'response',
] as const;

export type CampaignObjective = (typeof CAMPAIGN_OBJECTIVES)[number];

export const CAMPAIGN_TYPES = [
  'preReleaseHype',
  'singleAlbumPlaylistPromotion',
  'artistDevelopment',
  'eventAmplification',
  'catalogReEngagement',
  'soundGrowthTrendAmplification',
  'fanGrowth',
  'd2cConversions',
] as const;

export type CampaignType = (typeof CAMPAIGN_TYPES)[number];

export const MEDIA_PLATFORMS = [
  'instagram',
  'tiktok',
  'google',
  'spotify',
  'appleMusic',
  'facebook',
] as const;

export type MediaPlatform = (typeof MEDIA_PLATFORMS)[number];

export const MEDIA_PLAN_GOAL = [
  'videoViews',
  'demandGen',
  'display',
  'performanceMax',
  'search',
  'shopping',
  'video',
] as const;

export type MediaPlanGoal = (typeof MEDIA_PLAN_GOAL)[number];

// @TODO WMG1-604 - Figure out the proper currency codes. They might come from
//                  somewhere else.
export const CURRENCY_CODES = [
  'USD',
  'EUR',
  'GBP',
  'CAD',
  'AUD',
  'JPY',
  'CHF',
  'NZD',
  'SEK',
  'NOK',
  'DKK',
  'PLN',
  'MXN',
  'BRL',
  'INR',
  'CNY',
  'KRW',
  'SGD',
  'HKD',
  'ZAR',
] as const;

export type CurrencyCode = (typeof CURRENCY_CODES)[number];

export const FREQUENCY_PERIODS = ['day', 'week'] as const;

export type FrequencyPeriod = (typeof FREQUENCY_PERIODS)[number];

export const PLATFORM_MAP = {
  facebook: {
    labelKey: 'facebook',
    icon: 'facebook',
    dataColor: 2,
  },
  tiktok: {
    labelKey: 'tiktok',
    icon: 'tiktok',
    dataColor: 1,
  },
  google: {
    labelKey: 'google',
    icon: 'google',
    dataColor: 7,
  },
  instagram: {
    labelKey: 'instagram',
    icon: 'instagram',
    dataColor: 3,
  },
  spotify: {
    labelKey: 'spotify',
    icon: 'spotify',
    dataColor: 4,
  },
  appleMusic: {
    labelKey: 'appleMusic',
    icon: 'apple',
    dataColor: 5,
  },
} as const;

// Platform Table Grid Column Widths
// Total width of grid columns: 1280px - 120px (13 gaps of 8px + 16px padding) = 1160px
// Columns:
// 1. Budget
// 2. Market
// 3. Goal
// 4. Custom audience size
// 5. Frequency
// 6. Results
// 7. Cost per result
// 8. Result rate
// 9. Impressions
// 10. Reach
// 11. Video views
// 12. Clicks
// 13. Engagement
// 14. Actions

export const PLATFORM_TABLE_GRID_COLUMNS =
  '120px 158px 142px 120px 58px 90px 66px 50px 70px 62px 62px 62px 80px 20px' as const;

export const MOCK_MEDIA_PLAN: DigitalMediaPlan = {
  partyId: 1,
  campaignName: 'Test Campaign',
  trackId: '1234567890',
  objectives: ['awareness', 'engagement'],
  campaignType: 'preReleaseHype',
  markets: ['DE'],
  startDate: new Date(),
  endDate: new Date(),
  frequency: { times: 3, period: 'week' },
  currency: 'USD',
  totalBudget: 10000,
  platforms: [
    {
      mediaPlatform: 'facebook',
      plans: [
        {
          market: 'DE',
          goal: 'videoViews',
          budget: 10000,
          audienceSize: 10000,
          frequency: { times: 3, period: 'week' },
        },
      ],
    },
    {
      mediaPlatform: 'tiktok',
      plans: [
        {
          market: 'DE',
          goal: 'demandGen',
          budget: 10000,
          audienceSize: 10000,
          frequency: { times: 3, period: 'week' },
        },
      ],
    },
  ],
};
